import script from "./AdminPluginExpireManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPluginExpireManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPluginExpireManage.vue?vue&type=style&index=0&id=68f0e000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f0e000"]])

export default __exports__